import React, { useContext } from 'react';
import { PhoneBox, PhoneLabel, PhoneNumber } from '../StyledComponents';
import AnsweringServiceContext from '../AnsweringServiceContext';

/**
 * The card to display the phone number for the user's Answering Service
 * provider. Meant to be displayed above the listing table.
 * */
const PhoneBoxPopulated: React.FC = () => {
  // Grab their provider's phone number from the Onboarding Portal.
  const { portalConfig } = useContext(AnsweringServiceContext);
  if (!portalConfig) return null;
  const { answeringServicePhone } = portalConfig;

  return (
    <PhoneBox>
      <PhoneLabel>Paste this on your listings</PhoneLabel>
      <PhoneNumber>{answeringServicePhone}</PhoneNumber>
    </PhoneBox>
  );
};

export default PhoneBoxPopulated;
